import { render } from "./CheckoutSummery.vue?vue&type=template&id=78d5fa4f"
import script from "../js/checkout-summery.js?vue&type=script&lang=js&external"
export * from "../js/checkout-summery.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__